// components/ResourceDetailModalContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';
import ResourceDetailModal from './ResourceDetailModal';

const ResourceDetailModalContext = createContext(null);

export function ResourceDetailModalProvider({ children }) {
  const [currentItem, setCurrentItem] = useState(null);

  const openResourceDetail = useCallback((item) => {
    if (!item) return;
    setCurrentItem(item);
  }, []);

  const closeResourceDetail = useCallback(() => {
    setCurrentItem(null);
  }, []);

  return (
    <ResourceDetailModalContext.Provider value={{ openResourceDetail, closeResourceDetail }}>
      {children}
      <ResourceDetailModal
        item={currentItem}
        isOpen={!!currentItem}
        onClose={closeResourceDetail}
      />
    </ResourceDetailModalContext.Provider>
  );
}

export function useResourceDetailModal() {
  const ctx = useContext(ResourceDetailModalContext);
  if (!ctx) {
    throw new Error('useResourceDetailModal must be used within a ResourceDetailModalProvider');
  }
  return ctx;
}


